import { Component, Input, Output, EventEmitter } from '@angular/core';

/** Engagement scale labels, index = value - 1. Shared with the timeline session card. */
export const ENGAGEMENT_LABELS = ['Disengaged', 'Passive', 'Willing', 'Engaged', 'Leading'];

@Component({
  selector: 'leap-v2-engagement-bar',
  templateUrl: './leap-v2-engagement-bar.component.html',
  styleUrls: ['./leap-v2-engagement-bar.component.css'],
  standalone: false,
})
export class LeapV2EngagementBarComponent {
  @Input() value = 0;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<number>();

  readonly labels = ENGAGEMENT_LABELS;

  get fillWidth(): string {
    return this.value <= 0 ? '0%' : `${(this.value / 5) * 100}%`;
  }

  get stepLabel(): string {
    return this.isEmpty ? 'Not set' : ENGAGEMENT_LABELS[this.value - 1];
  }

  get isEmpty(): boolean {
    return this.value <= 0;
  }

  onBarClick(event: MouseEvent, track: HTMLElement): void {
    if (this.disabled) return;
    const rect = track.getBoundingClientRect();
    const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
    const newValue = Math.max(1, Math.round(ratio * 5));
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
